import React, {useEffect, useState} from "react";

import {Box, Checkbox, FormControl, FormControlLabel, InputLabel, NativeSelect} from "@material-ui/core";
import {monthListForFilters, yearList} from "../../../utils/dates";
import {getHuntersList} from "../../deals/list/api";
import AutoSuggest from "../../../components/UI/AutoSuggest";
import cookiesService from "../../../services/cookiesService";
import {
  filterV1Months,
  filterV1Years,
  filterV2Months,
  filterV2Years,
} from "../cutover";

const cookiesServiceInstance = cookiesService.getService();
const Filters = ({
  state,
  setState,
  handleChangeHunterId,
  hunterId,
  archiveDetailsMode,
}) => {
  const {position_code} = cookiesServiceInstance.getUserData();
  const [huntersArr, setHuntersArr] = useState([]);

  const years = archiveDetailsMode
    ? filterV1Years(yearList)
    : filterV2Years(yearList);
  const months = archiveDetailsMode
    ? filterV1Months(monthListForFilters, state.year)
    : filterV2Months(monthListForFilters, state.year);

  useEffect(() => {
    getHuntersList()
      .then(res => {
        setHuntersArr(res);
      })
      .catch(() => {
      });
  }, []);

  const handleChange = e => {
    const {name, value, checked} = e.target;
    if (name === "with_contract") {
      setState({...state, with_contract: checked ? 1 : 0});
      return;
    }
    setState({...state, [name]: value});
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        flexWrap: "wrap",
        gap: "20px",
        padding: "20px 0"
      }}
    >
      {position_code === "SALE_HEAD_HEAD" || position_code === "SALE_HEAD" ? (
        <Box sx={{minWidth: 300}}>
          <AutoSuggest
            name="employee_id"
            label="Хантер"
            list={huntersArr}
            valueKey="employee_id"
            showKey="fio"
            selected={+hunterId}
            onChange={handleChangeHunterId}
            disableClearable={true}
          />
        </Box>
      ) : null}
      <FormControl style={{minWidth: "200px"}}>
        <InputLabel htmlFor="year-select" shrink>
          Год
        </InputLabel>
        <NativeSelect
          value={state.year}
          onChange={handleChange}
          inputProps={{
            name: "year",
            id: "year-select"
          }}
        >
          {years.map(el => {
            return (
              <option value={el.year} key={el.id}>
                {el.year}
              </option>
            );
          })}
        </NativeSelect>
      </FormControl>
      <FormControl style={{minWidth: "200px"}}>
        <InputLabel htmlFor="month-select" shrink>
          Месяц
        </InputLabel>
        <NativeSelect
          value={state.month}
          onChange={handleChange}
          inputProps={{
            name: "month",
            id: "month-select"
          }}
        >
          {months.map(el => {
            return (
              <option value={el.id} key={el.id}>
                {el.month}
              </option>
            );
          })}
        </NativeSelect>
      </FormControl>
      <FormControlLabel
        control={
          <Checkbox
            name="with_contract"
            value={state.is_contract}
            onChange={handleChange}
            color="primary"
            style={{padding: 5}}
          />
        }
        label="+ договор"
      />
    </Box>
  );
};

export default Filters;
